// extracted by mini-css-extract-plugin
module.exports = {"IntroLarge":"IntroLarge_IntroLarge__11Eut","Main":"IntroLarge_Main__1mJmq","Line":"IntroLarge_Line__2zR4G"};